<template>
  <section class="temp" ref="toggleTemp">
    <div>
      <h3>
        Temperatur in Deutschland
        <Popper placement="bottom" offset-distance="5" arrow="true" class="popover">
          <template #content><span v-html="store.popupTemp"></span></template>
          <button class="info" type="button"></button>
        </Popper>
      </h3>
      <button class="toggle" v-on:click="toggleFunction"></button>
    </div>
    <TempLong></TempLong>
    <div class="toggled" ref="toggleElement">
      <TempMonth :dataTempMonth="dataTempMonth"></TempMonth>
      <TempDeviation :dataTempDeviation="dataTempDeviation"></TempDeviation>
    </div>
  </section>
</template>

<script>
import { store } from "../store";
import TempLong from "./tempLong.vue";
import TempMonth from "./tempMonth.vue";
import TempDeviation from "./tempDeviation.vue";
import Popper from "vue3-popper";

export default {
  components: {
    TempLong,
    TempMonth,
    TempDeviation,
    Popper,
  },
  data() {
    return {
      store,
      dataTempDeviation: [],
      dataTempMonth: [],
    };
  },
  methods: {
    toggleFunction() {
      this.$emit("child-event");
    },
  },
  mounted() {
    fetch(store.urlTemp)
      .then((response) => response.json())
      .then((data) => {
        store.dataTempLong = data.tempChange;
        store.dataTempDeviation = data["Grafik-unten"];
        store.dataTempMonth = [data["Grafik-oben-Kurve-1"], data["Grafik-oben-Kurve-2"]];

        this.dataTempMonth = [data["Grafik-oben-Kurve-1"], data["Grafik-oben-Kurve-2"]];
        this.dataTempDeviation = data["Grafik-unten"];
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
